import {
  CONNECT_ERROR_REASONS,
  type ConnectErrorReason,
} from "./ConnectErrorView";

export type ConnectSearch = {
  /**
   * Sealed link token. The param keeps its Spanish name: links already sent
   * to producers carry `/conectar?cliente=...`.
   */
  cliente?: string;
};

export type ConnectErrorSearch = { reason: ConnectErrorReason };

export type ConnectDoneSearch = { org: string[] };

function asString(value: unknown): string | undefined {
  return typeof value === "string" && value ? value : undefined;
}

export function validateConnectSearch(
  search: Record<string, unknown>
): ConnectSearch {
  return { cliente: asString(search.cliente) };
}

export function validateConnectErrorSearch(
  search: Record<string, unknown>
): ConnectErrorSearch {
  const raw = asString(search.reason);
  const known = CONNECT_ERROR_REASONS.find((reason) => reason === raw);
  return { reason: known ?? "failed" };
}

export function validateConnectDoneSearch(
  search: Record<string, unknown>
): ConnectDoneSearch {
  const raw = search.org;
  if (Array.isArray(raw)) {
    return {
      org: raw.filter((name): name is string => typeof name === "string"),
    };
  }
  const single = asString(raw);
  return { org: single ? [single] : [] };
}

export function startHref(linkToken?: string): string {
  return linkToken
    ? `/api/jd/start?cliente=${encodeURIComponent(linkToken)}`
    : "/api/jd/start";
}
